const HELPER_TEXT = "This field is read-only.";

export default HELPER_TEXT;
